import {
  CarouselSlider,
  getNavIdFromTitle,
  GridCol,
  GridContainer,
  GridRow,
  Icon,
  ICONS,
} from '@bob/library'
import Heading from '@websrc/App/Components/Heading/Heading'
import { formatString } from '@websrc/App/Helpers/formatting'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapHeroCarouselSpot } from '@websrc/DataMappers/mapSpot'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'
import React, { useState } from 'react'

import * as SC from './SpotHeroCarousel.style'

export interface SpotHeroCarouselProps {
  spot: ReturnType<typeof mapHeroCarouselSpot>['hero_carousel']
  isTopOfPage?: boolean
}

export const SpotHeroCarousel = ({ spot, isTopOfPage }: SpotHeroCarouselProps) => {
  const { items, caption } = spot
  const t = useStaticText()
  const [slide, setSlide] = useState<number>(0)
  const size = items.length
  const speed = 4

  const wrapperProps = {
    id: caption ? getNavIdFromTitle(caption) : undefined,
  }

  return (
    <GridContainer {...wrapperProps} data-testid={'caption'}>
      <GridRow>
        <GridCol tabIndex={0}>
          <CarouselSlider pause={true} slide={slide} speed={speed}>
            {items.map((item, i) => {
              // I know...
              const next = i + 1 === size ? 0 : i + 1
              const prev = i - 1 < 0 ? size - 1 : i - 1

              return (
                <SC.Wrapper key={i}>
                  <SC.AssetSection desktop={6} noGutter={true}>
                    <SC.AssetWrapper
                      sizes={`(min-width: 1024px) 800px`}
                      srcSetWidths={[320, 400, 600, 800, 1200]}
                      {...item.asset}
                      lazyLoading={false}
                    />
                  </SC.AssetSection>
                  <SC.ContentSection desktop={6} noGutter={true}>
                    <SC.TextSection>
                      <Heading
                        description={item.description}
                        headline={item.headline}
                        level={isTopOfPage ? 1 : 2}
                        noSpacing={true}
                        size={'l'}
                        skipWidth={true}
                      />
                      <SpotLinkAnchor ctaType={'tertiary'} link={item.link}>
                        <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                        <span>{item.link.cta_text}</span>
                      </SpotLinkAnchor>
                    </SC.TextSection>
                    <SC.NavSection>
                      <SC.NavHeadline>
                        {t.global.next}: {items[next].carousel_title}
                      </SC.NavHeadline>
                      <div>
                        <SC.NavButton aria-label={t.global.previous} onClick={() => setSlide(prev)}>
                          <Icon icon={ICONS.ARROW_LEFT} size={10} />
                        </SC.NavButton>
                        {formatString(t.global.x_of_y, i + 1, size)}
                        <SC.NavButton aria-label={t.global.next} onClick={() => setSlide(next)}>
                          <Icon icon={ICONS.ARROW_RIGHT} size={10} />
                        </SC.NavButton>
                      </div>
                    </SC.NavSection>
                  </SC.ContentSection>
                </SC.Wrapper>
              )
            })}
          </CarouselSlider>
        </GridCol>
      </GridRow>
    </GridContainer>
  )
}
